import { render, staticRenderFns } from "./FixedExchangeRateForm.vue?vue&type=template&id=a8bb564a&scoped=true&"
import script from "./FixedExchangeRateForm.vue?vue&type=script&lang=js&"
export * from "./FixedExchangeRateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bb564a",
  null
  
)

export default component.exports